import { render, staticRenderFns } from "./LeadTypeMigrationForm.vue?vue&type=template&id=617205f5&scoped=true&"
import script from "./LeadTypeMigrationForm.vue?vue&type=script&lang=ts&"
export * from "./LeadTypeMigrationForm.vue?vue&type=script&lang=ts&"
import style0 from "./LeadTypeMigrationForm.vue?vue&type=style&index=0&id=617205f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617205f5",
  null
  
)

export default component.exports